var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datepicker',{attrs:{"range":false,"lang":"es","circle":false,"text-format":"short","placeholder":"Fecha","date-format":{
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }